import React from "react"

import { withRouter } from "react-router-dom";

import AsyncSelect from '../AsyncSelect'

import BaseTable from "./BaseTable"

import ResourceActionsCell from "./cells/ResourceActionsCell"

import Backend from '../../../utils/Backend'
import General from '../../../utils/General'
import AuthManager from '../../../utils/AuthManager'
import Website from '../../../utils/Website'
import Currency from '../../../utils/Currency'

import moment from 'moment'

class ResourcesTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      website: props.website
    }

    this.table = React.createRef()
  }

  componentDidMount(){

  }


  _getColumns() {
    let {
      shop
    } = this.state

    return [
      {
        Header: 'Resource Name',
        accessor: 'name',
        width: 300,
        Cell: rowInfo => {
          let resource = rowInfo.original
          return (
            <div class="d-flex align-items-center">
            { resource.image &&
              <div class="symbol symbol-50 flex-shrink-0">
                  <img class="resource-thumbnail" src={resource.image.thumbnail} alt="photo"/>
              </div>
            }
              <div class={resource.image ? "ml-3" : ""}>
                  <span>{resource.name}</span>
              </div>
            </div>
          )
        }
      },
      {
        Header: 'Bookings No',
        accessor: 'sales_no',
      },
      {
        Header: 'Gross Sales',
        id: 'gross_sales',
        accessor: resource => Currency.format(resource.gross_sales, "")
      },
      {
        Header: 'Date Added',
        id: 'created_at',
        accessor: resource => moment(resource.created_at).format('DD/MM/YYYY'),
        type: "date",
        format: "%d %b %Y"
      },
      {
        Header: 'Actions',
        id: 'actions',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          return (
            <ResourceActionsCell
              resource={rowInfo.original}
              onEditPressed={resource => this.props.history.push(`/resources/${resource.id}`)}
            />
          )
        }
      }
    ]
  }


  render() {
    let {
      website,
      resource,
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={window.Api.Resources}
          params={{
            website_id: website.id
          }}
          title="Resources"
          columns={columns}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              style: {
                paddingLeft: 10,
                overflow: column.Header === "Actions" ? 'visible' : 'hidden'
              }
            }
          }}
          renderToolbar={() => {
            return (
              <div class="kt-portlet__head-toolbar">
                <div class="kt-portlet__head-wrapper">
                  <button
                    type="button"
                    class="btn btn-brand btn-icon-sm"
                    onClick={() => this.props.history.push(`/resources/add`)}
                  >
                    <i class="flaticon2-plus lh-1"></i>
                    Add Resource
                  </button>
                </div>
              </div>
            )
          }}
        />
      </>
    )
  }
}

export default withRouter(ResourcesTable);
